module.exports = __webpack_public_path__ + "img/onboardingFormDefaultPhoto_ca.9ad7bc92.svg";